module.exports = __webpack_public_path__ + "assets/img/partners/fer-color.svg";